"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBrandedDef = void 0;
const parseDef_1 = require("../parseDef");
function parseBrandedDef(_def, refs) {
    return (0, parseDef_1.parseDef)(_def.type._def, refs);
}
exports.parseBrandedDef = parseBrandedDef;
